/**
 * Suggerimenti per il campo stanza. Non è un vincolo: il campo resta libero,
 * questi sono solo i locali che il progetto conosce già (schema terminali del
 * riscaldamento, lavori/01 §2.1) più gli ambiti che non sono stanze ma che in
 * cantiere si fotografano di continuo.
 */
export const STANZE_SUGGERITE = [
  // Piano terra
  'Cucina',
  'Soggiorno',
  'Sala/studio',
  'Camera/studio PT',
  'Ingresso/disimpegno PT',
  'Bagno PT',
  // Piano primo
  'Camera matrimoniale',
  'Camera 2',
  'Camera 3',
  'Camera 4/studio',
  'Disimpegno P1',
  'Bagno P1',
  // Fuori dai locali abitati
  'Sottotetto',
  'Autorimessa / centrale termica',
  'Deposito',
  'Vano scala',
  'Copertura',
  'Facciate',
  'Giardino',
  'Pozzo',
] as const;
